import isCssCustomizer from "@toolkit/Framework/Common/Utilities/lodash/isCssCustomizer";
import { NoInfer, RecursivePartial } from "@toolkit/Framework/Types/Common";
import mergeWith from "lodash/mergeWith";

function mergeProps<T, U>(object1: T | undefined, object2: U | undefined): T & U;
function mergeProps<T>(object1: RecursivePartial<NoInfer<T>> | undefined, object2: NoInfer<T> | undefined): T;
function mergeProps<T>(object1: NoInfer<T> | undefined, object2: RecursivePartial<NoInfer<T>> | undefined): T {
    return mergeWith({}, object1, object2, (object: any, source: any, key: string) => {
        const isCss = isCssCustomizer(object, key);

        if (Array.isArray(object)) {
            if (isCss) {
                return object.concat(source);
            }

            return source;
        }
    });
}

export default mergeProps;
